import styled from 'styled-components';

export const EndOfBuses = styled.div`
  background: #d1e5ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
  padding: 2rem 2rem 1.5rem;
  margin-top: -5px;
  cursor: pointer;
`;
export const ToggleText = styled.span`
  color: #777;
  font-size: 1.2rem;
`;
export const ToggleLink = styled.a`
  font-size: 1.2rem;
  padding: 0 0.5rem;
`;
